export default "__VITE_ASSET__4HyPzOqO__"